import { render, staticRenderFns } from "./noticeRulesForm.vue?vue&type=template&id=93ead166&scoped=true&"
import script from "./noticeRulesForm.vue?vue&type=script&lang=js&"
export * from "./noticeRulesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ead166",
  null
  
)

export default component.exports